import React from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FleetSection from './components/FleetSection';
import WhyUsSection from './components/WhyUsSection';
import AboutSection from './components/AboutSection';
import ReviewsSection from './components/ReviewsSection';
import InquirySection from './components/InquirySection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App bg-black min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <FleetSection />
        <WhyUsSection />
        <AboutSection />
        <ReviewsSection />
        <InquirySection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
